import React from 'react';
import { Switch, Route } from 'react-router';
import { useSelector } from 'react-redux';
import UserEdit from '../UserEdit';
import ProfileTopTabs from '../../profile/ProfileTopTabs';
import UserNotifications from '../UserNotifications';
import { selectUser } from '../../../store/modules/users/selectors';
import UserCreate from '../UserCreate';

type Props = {
  isNewUser: boolean;
};

const UserProfile = ({ isNewUser }: Props) => {
  const user = useSelector(selectUser);

  return (
    <>
      <Switch>
        {!isNewUser && <ProfileTopTabs loading={user.loading} tabResource="user" />}
      </Switch>
      <Switch>
        <Route exact path="/dashboard/admin/users/new/profile">
          <UserCreate />
        </Route>
        <Route exact path="/dashboard/admin/users/:id/profile">
          <UserEdit />
        </Route>
        <Route exact path="/dashboard/admin/users/:id/admin">
          <UserEdit showOnlyAdminSettings />
        </Route>
        <Route exact path="/dashboard/admin/users/:id/notifications">
          <UserNotifications />
        </Route>
      </Switch>
    </>
  );
};

export default UserProfile;
